import { deconstructUri } from '@shared/helpers/deconstructUri';
import { Maker } from './buildMachine';
import { Ctx, Snap } from './core';
import { queuesFallback } from './queuesFallback';
import { getUrlWithTransactionId } from '@shared/transactionId/getUrlWithTransactionId';
import { callEventListeners } from '@shared/events/callEventListeners';

export const tail: Maker<Ctx, Snap, null> = ({
  makeEffectGroup,
  makeEffect,
}) => [
  makeEffectGroup(
    'queuesFallback',
    (_, { pass }) => pass(null),
    queuesFallback,
  ),

  makeEffect(
    'analytics',
    (_, { ctx, skip, pass }) => {
      const { protocol, domain, path } = deconstructUri(
        `${ctx.config.utiqHost}/op/idconnect`,
      );

      if (!protocol || !domain || !path)
        return skip(
          `Data missing from Utiq host - protocol: ${protocol}, domain: ${domain}, path: ${path}`,
        );

      const event = Object.keys(ctx.analytics)[0];

      if (!event) return skip('!event');

      const shouldAddQueryParam = [
        'ids_set',
        'ids_not_set',
        'consent_granted',
      ].includes(event);

      const initialParam = shouldAddQueryParam ? '&initial=true' : '';

      const url = getUrlWithTransactionId(
        `${protocol}://${domain}/${path}/mno-precheck?type=${event}${initialParam}`,
      );

      return pass({ event, url });
    },

    ({ event, url }, { ctx }) => {
      delete ctx.analytics[event];

      ctx.axios.instance({
        method: 'get',
        url,
        timeout: 4000,
      });
    },
  ),

  makeEffect(
    'isFirstRun',
    (_, { ctx, cond }) => cond(ctx.isFirstRun, 'cxt.isFirstRun'),
    (_, { ctx }) => {
      ctx.isFirstRun = false;
      callEventListeners('onInitialised', 'Utiq', {});
    },
  ),
];
